import { useMutation, useQueryClient } from '@tanstack/react-query';

import { api } from '../api/client';
import { ApiError } from '../api/errors';

import { authKeys } from './hooks';
import { useAuthStore } from './store';

export interface LoginArgs {
  email: string;
  password: string;
}

export const useLogin = () => {
  const qc = useQueryClient();
  const setCurrentUser = useAuthStore((s) => s.setCurrentUser);

  return useMutation({
    mutationFn: async (body: LoginArgs) => {
      const result = await api.POST('/api/auth/login', { body });
      if (result.error) {
        throw new ApiError(result.response.status, result.error.error);
      }
      return result.data.user;
    },
    onError: (err: unknown) => {
      if (!(err instanceof ApiError)) throw err;
    },
    onSuccess: (user) => {
      setCurrentUser(user);
      qc.setQueryData(authKeys.me, user);
    },
  });
};

export const useLogout = () => {
  const qc = useQueryClient();
  const clear = useAuthStore((s) => s.clear);

  return useMutation({
    mutationFn: async () => {
      const result = await api.POST('/api/auth/logout', {});
      if (result.error) {
        throw new ApiError(result.response.status, result.error.error);
      }
    },
    onSuccess: () => {
      clear();
      qc.clear();
    },
  });
};
